import React, { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

interface PopupProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: React.ReactNode;
  actions?: React.ReactNode;
  width?:string;
  height?:string;
}

const Popup: FC<PopupProps> = ({ open, onClose, title, content, actions, width, height }) => {
  return (
    <Dialog open={open} onClose={onClose} className="popup"  PaperProps={{
      style: {
        width: width || 'auto',
        height: height || 'auto',
        maxWidth: width || 'auto'
      },
    }}>
      <DialogTitle className="dialog-title">{title}</DialogTitle>
      {content && (
        <DialogContent className="dialog-content">{content}</DialogContent>
      )}
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default Popup;
